import { AfterViewInit, Component, OnInit, ViewChild, Inject } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialog, MatSort, MatTableDataSource, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import { AppService } from "src/_services/app.service";
import { RunnerMappingModal } from "../market-mapping-table/market-mapping-table.component";

type mapEvents = {
  BEventId: string;
  bEventName: string;
  bEventId: string;
  SRevent: string;
  BCompetitionId: string;
  SCompetitionId: string;
  BCompetitionName: string;
  SCompetitionName: string;
  SSportId: string;
};

@Component({
  selector: "app-market-mapping",
  templateUrl: "./market-mapping.component.html",
  styleUrls: ["./market-mapping.component.scss"],
})
export class MarketMappingComponent implements OnInit, AfterViewInit {
  @ViewChild('sortUnmapped') sortUnmapped: MatSort;
  @ViewChild('sortMapped') sortMapped: MatSort;
  sportId = new FormControl([]);
  mappedStatusFilterDropdown = new FormControl([]);
  OrgBFEventsList: any[] = [];
  orgMappedEvents = new MatTableDataSource<any>();
  mappedEvents = new MatTableDataSource<any>();
  unmappedEvents = new MatTableDataSource<any>();
  mappedEventsSource: any[] = [];
  unmappedEventsSource: any[] = [];
  mappedSearchText: string = "";
  unmappedSearchText: string = "";
  mappedStatusFilter: string = "ALL";
  activeTabIndex: number = 1;

  ProviderId: string = "BetFair";
  sportsList: any[] = [];
  sportIdMap = {
    "4": "sr:sport:21",
    "1": "sr:sport:1",
    "2": "sr:sport:5",
    "7522": "sr:sport:2",
    "7511": "sr:sport:3",
  };
  selected: any = {
    startDate: null,
    endDate: null,
  };
  bfmarket = [];
  srmarket = [];
  start: any;
  end: any;
  sId = "";
  startOfDay = moment().subtract(1, "days").startOf("day");
  endOfDay = moment().subtract(1, "days").endOf("day");
  ranges: any = {
    Today: [moment().startOf("day"), moment()],
    Yesterday: [
      moment(this.startOfDay),

      moment(this.endOfDay),
    ],
    "Last 7 Days": [
      moment(moment().subtract(6, "days").startOf("day")),
      moment(),
    ],
    "Last 30 Days": [
      moment(moment().subtract(29, "days").startOf("day")),
      moment(),
    ],
    "This Month": [moment().startOf("month"), moment()],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };
  mappedEventsTableHeaders: string[] = [
    "OpenDate",
    "BetFair EventId",
    "BetFair EventName",
    // "SportRadar EventId",
    // "SR Event Name",
    "SR Competition Name",
    // "SR SportID",
    "BF Market",
    "SR Market",
    "Max Bets",
    "Max Risk",
    "Status",
    "Actions",
  
  ];

  UnmappedEventsTableHeaders: string[] = [
    "OpenDate",
    "BetFair EventId",
    "BetFair EventName",
    "SportRadar EventId",
    "SR Event Name",
    "SR SportID",
    "Actions",
  ];

  sportSettings: any = {};
  mappedStatusFilterOptions = [
    { item_id: "ALL", item_text: "All Status" },
    { item_id: "ACTIVE", item_text: "Active" },
    { item_id: "BLOCKED", item_text: "Blocked" },
  ];
  mappedStatusFilterSettings: any = {};

  constructor(private appService: AppService, private router: Router,private activetedRoute: ActivatedRoute,public dialog: MatDialog) {}

  ngOnInit() {
    this.selected.startDate = moment(new Date().setHours(0, 0, 0, 0));
    this.selected.endDate = moment(new Date().setHours(23, 59, 59));
    this.activetedRoute.queryParams.subscribe((params) => {
      this.sId = params["sportId"];
      this.start = params["startDate"];
      this.end = params["endDate"];
    });
    if (this.start !== undefined && this.end !== undefined) {
      this.selected.startDate = moment(parseInt(this.start))
      this.selected.endDate = moment(parseInt(this.end))
    }
    this.sportSettings = {
      singleSelection: true,
      idField: "SportId",
      textField: "SportName",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.mappedStatusFilterSettings = {
      singleSelection: true,
      idField: "item_id",
      textField: "item_text",
      allowSearchFilter: false,
      closeDropDownOnSelection: true,
      itemsShowLimit: 1,
    };
    this.mappedStatusFilterDropdown.setValue([this.mappedStatusFilterOptions[0]]);

    this.getSportsByProvider(this.ProviderId);
  }

  ngAfterViewInit() {
    this.unmappedEvents.sort = this.sortUnmapped;
    this.unmappedEvents.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'OpenDate': return item.open_date;
        default: return item[property];
      }
    };
    this.mappedEvents.sort = this.sortMapped;
    this.mappedEvents.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'OpenDate': return item.open_date;
        default: return item[property];
      }
    };
  }

  getOpenDate = (date: number) => {
    return moment(date).format("DD MMM YYYY hh:mm A");
  };

  getSportsByProvider(providerId) {
    try {
      this.appService.getSportData(providerId).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.sportsList = res.sports;
          if (this.sId !== "") {
            const index = this.sportsList.findIndex(sport => sport.SportId.toLowerCase() === this.sId);
            this.sportId.setValue([this.sportsList[index]]);
            this.getMapEvents(this.selected.startDate,this.selected.endDate,this.sportIdMap[this.sportId.value[0].SportId]);
          }
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  onSelectedSportName(SportId) {
    this.sportId.setValue([SportId]);
    this.getMapEvents(
      this.selected.startDate,
      this.selected.endDate,
      this.sportIdMap[this.sportId.value[0].SportId]
    );
  }

  onDateChangeHandler() {
    if (this.sportId.value.length !== 0) {
      this.getMapEvents(
        this.selected.startDate,
        this.selected.endDate,
        this.sportIdMap[this.sportId.value[0].SportId]
      );
    }
  }

  handleChange(e, element) {
    let status = "BLOCKED"
    if (e.checked) {
      status = "ACTIVE"
    }
    let filters = {
      eventId: element.bEventId,
      marketId: element.bMarketId !== undefined ? element.bMarketId : "",
      sportId: element.bSportId,
      status: status
    }
    this.appService
      .blockMappedMarket(filters)
      .subscribe((res) => {
        if (res.status === "RS_OK") {
          this.appService.openSuccessBar(res.errorDescription);
          // this.getOurOperators();
        } else {
          this.appService.openErrorBar(res.errorDescription);
        }
      });
    
  }

  unMapMarket(event) {
    const payload = {
      bSportId: event.bSportId,
      bEventId: event.bEventId,
      bMarketId: event.bMarketId,
    };
    
    try {
      this.appService.unMapMarket(payload).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.appService.openSuccessBar("Unmapped");
          this.getMapEvents(
            this.selected.startDate,
            this.selected.endDate,
            this.sportIdMap[this.sportId.value[0].SportId],
          )
          
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}

  }
  getMapEvents(startDate, endDate, sportId) {
    let filters = {
    startDate: startDate.valueOf(),
    endDate: endDate.valueOf(),
    sportId: sportId,
    sports: [],
    page: 0,
    pageSize: 0,
    sort: 0
    }
    try {
      this.appService
        .getB2sMarketMap(filters)
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.orgMappedEvents.data = res.b2SMappedMarket || [];
            this.mappedEventsSource = res.b2SMappedMarket || []
            this.unmappedEventsSource = res.b2SUnMappedMarket || [];
            this.applyMappedSearch();
            this.applyUnmappedSearch();
          } else {
            if (res.errorDescription === "Invalid Token!") {
              sessionStorage.clear();
              this.router.navigateByUrl("/login");
            }
          }
        });
    } catch (err) {}
  }

  openDialog(ele) {}

  applyMappedSearch() {
    const keyword = (this.mappedSearchText || "").trim().toLowerCase();
    this.mappedEvents.data = this.mappedEventsSource.filter((event) => {
      const searchMatched = !keyword || this.matchesBetfairSearch(event, keyword);
      const statusMatched = this.matchesMappedStatusFilter(event);
      return searchMatched && statusMatched;
    });
  }

  applyUnmappedSearch() {
    const keyword = (this.unmappedSearchText || "").trim().toLowerCase();
    if (!keyword) {
      this.unmappedEvents.data = this.unmappedEventsSource;
      return;
    }
    this.unmappedEvents.data = this.unmappedEventsSource.filter((event) =>
      this.matchesBetfairSearch(event, keyword)
    );
  }

  private matchesBetfairSearch(event: any, keyword: string): boolean {
    const eventId = String(event && event.bEventId !== undefined ? event.bEventId : "").toLowerCase();
    const eventName = String(event && event.bEventName ? event.bEventName : "").toLowerCase();
    return eventId.includes(keyword) || eventName.includes(keyword);
  }

  onTabChange(event: any) {
    this.activeTabIndex = event && event.index !== undefined ? event.index : 0;
  }

  getActiveTabSearchText(): string {
    return this.activeTabIndex === 0 ? this.mappedSearchText : this.unmappedSearchText;
  }

  onActiveTabSearchChange(value: string) {
    if (this.activeTabIndex === 0) {
      this.mappedSearchText = value || "";
      this.applyMappedSearch();
      return;
    }
    this.unmappedSearchText = value || "";
    this.applyUnmappedSearch();
  }

  onMappedStatusFilterChange(value: string) {
    this.mappedStatusFilter = value || "ALL";
    this.applyMappedSearch();
  }

  onMappedStatusFilterDropdownChange() {
    const selected =
      this.mappedStatusFilterDropdown &&
      this.mappedStatusFilterDropdown.value &&
      this.mappedStatusFilterDropdown.value[0]
        ? this.mappedStatusFilterDropdown.value[0].item_id
        : "ALL";
    this.onMappedStatusFilterChange(selected);
  }

  private matchesMappedStatusFilter(event: any): boolean {
    if (this.mappedStatusFilter === "ALL") {
      return true;
    }
    const eventStatus = String(event && event.status ? event.status : "").toUpperCase();
    return eventStatus === this.mappedStatusFilter;
  }

  redirectToMarkets(ele) {
    this.router.navigate(["administration/market-map"], {
      queryParams: {
        bfsportId: this.sportId.value[0].SportId,
        srsportId: ele.sSportId,
        bfeventId: ele.bEventId,
        sreventId: ele.sEventId,
        startDate: this.selected.startDate,
        endDate: this.selected.endDate,
      },
    });
  }

  editMaxBets(element) {
    const dialogRef = this.dialog.open(EditMaxBetsModal, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {
        element: element,
        maxBets: element.maxBets || 0
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getMapEvents(
          this.selected.startDate,
          this.selected.endDate,
          this.sportIdMap[this.sportId.value[0].SportId]
        );
      }
    });
  }

  edit(element: any) {
    try {
      this.appService
        .viewMarketDetails({
          bEventId: element.bEventId,
          bMarketId: element.bMarketId,
          bSportId: element.bSportId,
        })
        .subscribe((res) => {
          if (res.status === "RS_OK" && res.mappedMarket) {
            const obj = res.mappedMarket;
            const bfrunners = [];
            const srrunners = [];
            for (let i = 0; i < obj.Market.Runners.length; i++) {
              bfrunners.push({
                RunnerId: obj.Market.Runners[i].BetFair,
                RunnerName: obj.Market.Runners[i].BetFairName,
              });
              srrunners.push({
                RunnerId: obj.Market.Runners[i].SportRadar,
                RunnerName: obj.Market.Runners[i].SportRadarName,
              });
            }
            const preMappedRunners = (obj.Market.Runners || []).map((runner) => ({
              bfRunnerId: runner && runner.BetFair ? runner.BetFair : "",
              bfRunnerName: runner && runner.BetFairName ? runner.BetFairName : "",
              srRunnerId: runner && runner.SportRadar ? runner.SportRadar : "",
              srRunnerName: runner && runner.SportRadarName ? runner.SportRadarName : "",
            }));

            this.bfmarket = [{
              CompetitionId: obj.Competition.BetFair,
              EventId: obj.Event.BetFair,
              MarketId: obj.Market.BetFair,
              MarketName: obj.Market.BetFairMarketName,
              SportId: obj.Sport.BetFair,
              Runners: bfrunners,
            }];

            this.srmarket = [{
              CompetitionId: obj.Competition.SportRadar,
              EventId: obj.Event.SportRadar,
              MarketId: obj.Market.SportRadar,
              MarketName: obj.Market.SportRadarMarketName,
              SportId: obj.Sport.SportRadar,
              Runners: srrunners,
            }];

            const dialogRef = this.dialog.open(RunnerMappingModal, {
              backdropClass: "backdropBackground",
              hasBackdrop: true,
              data: {
                bfsportId: element.bSportId,
                srsportId: element.sSportId,
                bfeventId: element.bEventId,
                sreventId: element.sEventId,
                bfmarketId: obj.Market.BetFair,
                srmarketId: obj.Market.SportRadar,
                selectedBFMarket: this.bfmarket,
                selectedSRMarket: this.srmarket,
                mapped: true,
                maxBets: obj.MaxBets || element.maxBets || 0,
                maxRisk: obj.MaxRisk || element.maxRisk || 0,
                status: obj.Status,
                preMappedRunners: preMappedRunners,
              },
            });

            dialogRef.afterClosed().subscribe((result) => {
              if (result) {
                this.getMapEvents(
                  this.selected.startDate,
                  this.selected.endDate,
                  this.sportIdMap[this.sportId.value[0].SportId]
                );
              }
            });
          } else {
            this.appService.openErrorBar(res.errorDescription || "Failed to load market details");
            if (res.errorDescription === "Invalid Token!") {
              sessionStorage.clear();
              this.router.navigateByUrl("/login");
            }
          }
        });
    } catch (err) {}
  }
}

@Component({
  selector: "edit-max-bets-dialog",
  templateUrl: "./edit-max-bets-dialog.component.html",
  styleUrls: ["./market-mapping.component.scss"],
})
export class EditMaxBetsModal {
  maxBets: number | null = null;
  element: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appService: AppService,
    public router: Router,
    public dialogRef: MatDialogRef<EditMaxBetsModal>
  ) {
    this.element = data.element;
    // Get maxBets from element, checking multiple possible property names
    this.maxBets = data.maxBets || data.element.maxBets || data.element.max_bets || data.element.maxBetsConfig || null;
  }

  submit() {
    const payload = {
      eventId: this.element.bEventId,
      sportId: this.element.bSportId,
      marketId: this.element.bMarketId,
      maxBets: this.maxBets || 0
    };

    this.appService.editB2sMappedMarket(payload).subscribe(
      (res) => {
        if (res.status === "RS_OK") {
          this.appService.openSuccessBar(res.errorDescription || "Max bets updated successfully");
          this.dialogRef.close(true);
        } else {
          this.appService.openErrorBar(res.errorDescription);
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      },
      (err) => {
        this.appService.openErrorBar("Error updating max bets");
      }
    );
  }
}
